module.exports = __webpack_public_path__ + "files/9021a269bde830df35f457f87a99f1f8.png";